











import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import ProductResourceHelperComponents2Header from './product-resource-helper-components-2-header.vue'
import ProductResourceHelperComponents3ResourceList from './product-resource-helper-components-3-resource-list.vue'

// const namespace = 'digitalCurrency'

@Component({
  name: 'ProductResourceHelperComponents1MainPage',
  components: {
    ProductResourceHelperComponents2Header,
    ProductResourceHelperComponents3ResourceList
  }
})
class ProductResourceHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) productResourceId?: string
  @Prop({ default: false }) showInNav?: boolean


  emitToggleShowContent ({ contentName, isVisible }: { contentName: string, isVisible?: boolean}) {
    this.$emit('toggleShowContent', { contentName, isVisible })
  }
}
export default ProductResourceHelperComponents1MainPage
